module.exports = __webpack_public_path__ + "static/IMG-39a6f304dbe5414f4ad4c9f894cee7a3-V-207b7b394ff42e3795a11ed7c8bc7180.webp";